import { async, debounceTime, first, ReplaySubject, switchMap } from "./operators.js";
import { shareReplayRC } from "./share-replay-rc.js";
export function switchDebounce(time) {
    return (target, key, decorator) => {
        const requestSymbol = Symbol('request');
        const responseSymbol = Symbol('response');
        const fn = target[key];
        Object.defineProperty(target, key, {
            value(...args) {
                const requests$ = this[requestSymbol] = this[requestSymbol]
                    || new ReplaySubject(0);
                const response$ = this[responseSymbol] = this[responseSymbol] || requests$.pipe(debounceTime(time, async), switchMap(fn => fn()), shareReplayRC(1));
                requests$.next(() => fn.apply(this, args));
                return response$.pipe(first()).toPromise();
            }
        });
    };
}
//# sourceMappingURL=switch-debounce.js.map